export interface GanttItemMapping {
  timeline: string | null;
  startDate: string | null;
  endDate: string | null;
  dependencyEnabled: boolean;
  dependency: string | null;
}

export interface GanttChartColumnMapping {
  items: GanttItemMapping;
  subItems: GanttItemMapping;
}

export interface GanttChartItem {
  id: string;
  name: string;
  startDate?: number;
  endDate?: number;
  dependencies?: string[];
  subItems?: GanttChartItem[];
}

export interface GanttChartGroup {
  id: string;
  name: string;
  color: string;
  items: GanttChartItem[];
}

export const PossibleTypesForFields = {
  timeline: ["timeline"],
  date: ["date"],
  dependency: ["dependency"],
} as const;

export const EMPTY_ITEM_MAPPING: GanttItemMapping = {
  timeline: null,
  startDate: null,
  endDate: null,
  dependencyEnabled: false,
  dependency: null,
};

export type GanttStep = "mapping" | "items";
